module.exports = __webpack_public_path__ + "img/augmentive.8cff44b6.png";